// --- START OF FILE PaginaContratoStyle.js ---

import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`from { opacity: 0; } to { opacity: 1; }`;
const slideInRight = keyframes`
    from { transform: translateX(100%); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
`;

export const PaginaContratoContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(8px);
    z-index: 1500;
    display: flex;
    justify-content: flex-end;
    animation: ${fadeIn} 0.3s ease;
`;

export const Drawer = styled.div`
    width: 100%;
    max-width: 700px;
    height: 100%;
    background: #1c1c1c;
    display: flex;
    flex-direction: column;
    box-shadow: -10px 0px 30px rgba(0,0,0,0.5);
    animation: ${slideInRight} 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    
    @media (max-width: 700px) {
        max-width: 100%;
    }
`;

export const Header = styled.header`
    padding: 20px 30px;
    background: #252525;
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h2 { margin: 0; color: #E6AA3A; font-size: 24px; }
`;

export const MainContent = styled.main`
    padding: 30px;
    overflow-y: auto;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    gap: 30px;
`;

export const Section = styled.section`
    background: rgba(255,255,255,0.05);
    border-radius: 8px;
    
    h3 {
        margin: 0;
        padding: 15px 20px;
        font-size: 18px;
        color: #fff;
        border-bottom: 1px solid rgba(255,255,255,0.1);
    }
`;

export const InfoGrid = styled.div`
    padding: 20px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;

    @media (max-width: 500px) {
        grid-template-columns: 1fr;
    }
`;

export const InfoBox = styled.div`
    label {
        display: block;
        font-size: 12px;
        color: #fff;
        opacity: 0.6;
        margin-bottom: 8px;
        text-transform: uppercase;
    }

    input {
        width: 100%;
        background: transparent;
        border: none;
        color: #fff;
        font-size: 16px;
        padding: 5px 0;
        border-bottom: 1px solid rgba(255,255,255,0.2);
        transition: border-color 0.3s;
        
        &:focus { 
            outline: none; 
            border-bottom-color: #E6AA3A;
        }
        &.desabilitado, &[readOnly] { 
            border-bottom-color: transparent;
            opacity: 0.8; 
            cursor: default;
        }
    }
`;

export const ActionGrid = styled.div`
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 15px;

    p {
        margin: 0 0 5px 0;
        color: #fff;
        opacity: 0.8;
        font-size: 14px;
        line-height: 1.5;
    }

    .confirm-input {
        height: 45px;
        background: rgba(0,0,0,0.3);
        border: 1px solid rgba(255, 255, 255, 0.2);
        color: #fff;
        padding: 0 15px;
        border-radius: 6px;
        font-size: 16px;
        margin-bottom: 10px;
        width: 100%;
        box-sizing: border-box;

        &:focus { outline: none; border-color: #E6AA3A; }
    }
`;

export const ActionButton = styled.button`
    border: none;
    border-radius: 6px;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
    background: #E6AA3A;
    color: #111;

    &.danger {
        background: #c0392b;
        color: #fff;
    }

    &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

export const Footer = styled.footer`
    padding: 20px 30px;
    background: #252525;
    display: flex;
    justify-content: flex-end;
    gap: 15px;
    flex-shrink: 0;
`;

// Mantendo compatibilidade com os nomes do seu componente JS
export const CloseButton = styled(ActionButton)`
    background: rgba(255,255,255,0.1);
    color: #fff;
`;
export const SaveButton = styled(ActionButton)``;
export const PaginaButtons = styled.div`
    position: absolute;
    top: 20px;
    right: 30px;
    display: flex;
    gap: 10px;
`;
export const ContratoDataContainer = styled.div``;
export const ContratoDataBox = styled.div``;
export const Funcoes = styled.div``;
export const RealizarRecompra = styled.div``;
export const RevalidarContrato = styled.div``;